import React from 'react';
import { ProgressSpinner } from '../components/progress-spinner/';
import { get } from 'lodash';

export const renderContainerChildren = (props, style, WrapperComponent = React.Fragment) => {
  const { children, collection = [], currentEntity, isLoadingData, hideLoader } = props;
  const isCollectionEmpty = !collection.length;
  const isMemberSelected = !!currentEntity;
  let showLoading = false;

  const renderedChildren = React.Children.map(children, child => {
    if (!child) {
      return null;
    }
    const {
      showIfCollectionEmpty,
      hideIfCollectionEmpty,
      showIfMemberSelected,
      hideIfMemberSelected,
      hideIfLoadingCollection,
      hideIfLoadingMember,
    } = child.props || {};
    const isHidden =
      (showIfCollectionEmpty && !isCollectionEmpty) ||
      (hideIfCollectionEmpty && isCollectionEmpty) ||
      (showIfMemberSelected && !isMemberSelected) ||
      (hideIfMemberSelected && isMemberSelected) ||
      (hideIfLoadingMember && isLoadingData) ||
      (hideIfLoadingCollection && isLoadingData && isCollectionEmpty);

    if (isHidden) {
      showLoading = showLoading || isLoadingData;
      return <div style={{ display: 'none' }}>{child}</div>;
    } else if (style) {
      const type = child.type;
      const name = (typeof type === 'string' ? type : type.name).toLowerCase();
      return (
        <div style={style} className={`child-container-${name}`}>
          {child}
        </div>
      );
    } else {
      return child;
    }
  });

  if (!renderedChildren || !renderedChildren.length) {
    return null;
  }
  return (
    <WrapperComponent>
      {renderedChildren}
      {showLoading && !hideLoader && <ProgressSpinner />}
    </WrapperComponent>
  );
};

export const renderFields = (props, renderWrapper) => {
  const {
    children,
    name,
    data,
    errorMessages = {},
    activeLanguage,
    onKeyDown,
    onValueChange,
    runValidation,
    scrollContainerId,
    valueChangeDelay,
    languages,
  } = props;

  return React.Children.map(children, (child, index) => {
    if (child) {
      let dataValue;
      let fieldName = child.props.multilingual ? `${child.props.name}_${activeLanguage}` : child.props.name;
      if (name) {
        fieldName = `${name}[${fieldName}]`;
      }
      if (child.props.valueOverride && child.props.dataValue) {
        dataValue = child.props.dataValue;
      } else if (data) {
        dataValue = get(data, child.props.fieldName || fieldName);
      }

      const cloneProps = {
        dataValue,
        onKeyDown,
        onValueChange,
        valueChangeDelay,
        runValidation: runValidation || child.props.runValidation,
        scrollContainerId,
        activeLanguage,
        languages,
        name: fieldName,
      };

      if (child.props.name && errorMessages && errorMessages[child.props.name]) {
        cloneProps.errorMessage = errorMessages[child.props.name];
      }

      if (data) {
        cloneProps.data = data;
      }

      const renderedChild = React.cloneElement(child, cloneProps);
      if (renderWrapper) {
        return renderWrapper(renderedChild, index);
      }
      return renderedChild;
    }
  });
};
